import { Observable, map } from "rxjs";
import { ChartData } from "src/app/_models/models";
import { WebServicesService } from "../webservices.service";
import { ApiService } from "./_api.service";
import { environment } from 'src/environments/environment';

export class StatApiService{
    constructor(private _ws: WebServicesService){}

    // Statistiche per grafici home
    get(): Observable<number[]> {
        const url = `${environment.wsBaseUrl}/api/Stats/All`;
        return this._ws.getWithoutCache(url);
    }

    getOne(id: number): Observable<ChartData[]> {
        const url = `${environment.wsBaseUrl}/api/Stats/${encodeURIComponent(id)}`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_STATS + id);
    }
}
